import { useHeightSyncState } from '../hooks/useHeightSyncState'

import { ReferFriendInfoCard } from './components/ReferFriendInfoCard'
import classes from './styles.module.scss'

type BuilderProps = {
  data: {
    items: {
      title: string
      text: string
      imageUrl: string
    }[]
  }
}

export const ReferFriendInfoCards = ({ data }: BuilderProps) => {
  const { registerHeight, maxHeight } = useHeightSyncState()

  return (
    <div className={classes.root}>
      {data.items.map((item, index) => (
        <ReferFriendInfoCard
          key={`${item.title}-${index}`}
          title={item.title}
          imageUrl={item.imageUrl}
          registerHeight={registerHeight}
          maxHeight={maxHeight}
        >
          <span dangerouslySetInnerHTML={{ __html: item.text }} />
        </ReferFriendInfoCard>
      ))}
    </div>
  )
}
